export const generateApplicationModel = () => ({
  name: '',
  password: '',
  loginTypes: [],
  description: '',
  tokenLifetime: '08:00:00',
});
